import * as React from 'react';
import { memo } from 'react';

import { SelectOption, SilentSelectField, breakpoints, useMediaQuery } from '@coursera/cds-core';

import withSingleTracked from 'bundles/common/components/withSingleTracked';
import { DEFAULT_SORTED_VALUE, NEW_SORTED_VALUE } from 'bundles/search-common/constants';
import type { SearchSortType } from 'bundles/search-common/types';

import _t from 'i18n!nls/search-common';

const TrackedSilentSelectField = withSingleTracked({ type: 'CHECKBOX' })(SilentSelectField);

type Props = {
  shouldHide?: boolean;
  setSortBy?: (sortBy: SearchSortType) => void;
  sortByValue?: string;
  hideLabelOnMobile?: boolean;
};

export const SortByIndex = ({
  setSortBy,
  sortByValue = DEFAULT_SORTED_VALUE,
  shouldHide,
  hideLabelOnMobile,
}: Props) => {
  const clickSortByOption = (value: SearchSortType) => {
    if (setSortBy) setSortBy(value);
  };
  const isMobile = useMediaQuery(breakpoints.down('sm'));
  if (shouldHide) {
    return null;
  }
  return (
    <TrackedSilentSelectField
      defaultValue={DEFAULT_SORTED_VALUE}
      value={sortByValue}
      trackingName="search_index"
      label={_t('Sort by')}
      labelPlacement={hideLabelOnMobile && isMobile ? 'none' : 'integrated'}
      onChange={(e) => clickSortByOption(e.target.value as SearchSortType)}
    >
      <SelectOption value={DEFAULT_SORTED_VALUE}>{_t('Best Match')}</SelectOption>
      <SelectOption value={NEW_SORTED_VALUE}>{_t('Newest')}</SelectOption>
    </TrackedSilentSelectField>
  );
};
export default memo(SortByIndex);
